import React from "react";

import { type FlowItemLink } from "../../../../features/Library/Flows/Designer/types";

import TopContent from "../BaseCard/TopContent";
import BottomContent from "../BaseCard/BottomContent";

export interface ILinkCardOwnProps {
  item: FlowItemLink;
}

const LinkCard: React.FC<ILinkCardOwnProps> = ({ item }) => (
  <>
    <TopContent {...item} />
    <BottomContent cardLabel={item.elementType} />
  </>
);

export default LinkCard;
